/**
 * Created by mobilport on 2018. 10. 01..
 */

export default function (app) {
	app.config(['$locationProvider',
		function ($locationProvider) {
			$locationProvider.hashPrefix('');
		}]);
};
